export const requireAsset = (path) => {
  try {
    return require(`../assets/${path}`);
  } catch (e) {
    console.error(e);
    return null;
    // return require("../assets/utils/image-not-found.png");
  }
};
